import React, { useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import { useTranslation, registerTranslations } from '@/hooks/useTranslation';
import Seo from '@/components/common/Seo';
import translations from './translations';

// Alle Sektionen importieren
import HeroSection from './HeroSection';
import PainSection from './PainSection';
import AISection from './AISection';
import ServiceSection from './ServiceSection';
import ProofSection from './ProofSection';
import TransformationSection from './TransformationSection';
import ProcessSection from './ProcessSection';
import FaqSection from './FaqSection';
import TrustSection from './TrustSection';
import FinalCTASection from './FinalCTASection';
import SavingsCalculatorSection from './SavingsCalculatorSection';

// Registrieren der seitenspezifischen Übersetzungen
registerTranslations('businessAppsPage', translations);

const BusinessAppsPage = () => {
  const { t } = useTranslation();

  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <>
      <Seo 
        title={t('businessAppsPage.meta.title')}
        description={t('businessAppsPage.meta.description')}
        canonical="/business-apps"
      />
      <Layout>
        <main>
          {/* 1. Hero - Der Ruf zum Abenteuer */}
          <HeroSection />
          
          {/* 2. Problem-/Pain-Sektion - Der Konflikt */}
          <PainSection />
          
          {/* 3. KI-Revolution - Technological Change */}
          <AISection />
          
          {/* 4. Vorstellung der Dienstleistung - Meeting the Mentor */}
          <ServiceSection />
          
          {/* 5. Beweis & Social Proof - Allies & Tests */}
          <ProofSection />
          
          {/* 6. Einsparpotenzial-Rechner */}
          <SavingsCalculatorSection />
          
          {/* 7. Status-quo-vs-Transformation - Die Belohnung */}
          <TransformationSection />
          
          {/* 8. Der Prozess-/Methoden-Fahrplan - Der Plan */}
          <ProcessSection />
          
          {/* 9. Einwand-Behandlung / FAQ - Ordeal - Zweifel besiegen */}
          <FaqSection />
          
          {/* 10. Risk Reversal & Trust Section - Magic Flight */}
          <TrustSection />
          
          {/* 11. Finaler CTA-Block - Return with Elixir */}
          <FinalCTASection />
        </main>
      </Layout>
    </>
  );
};

export default BusinessAppsPage; 